import { useIdsSelecting } from '@entities/common/IdsSelector/models';
import cn from 'classnames';
import { useEffect, useMemo } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { Header } from '@widgets/header';
import { InfinityList } from '@widgets/shared/InfinityList/index.tsx';
import { useLoadGroups } from '@features/common';
import { Add } from '@shared/assets';
import { parseGroups } from '@shared/helpers/parse-groups.ts';
import { usePlatformSettings } from '@shared/hooks/index.ts';
import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';
import { IconButton, ListBody, PageHead, TextButton } from '@shared/ui';
import { Blank } from '@src/library/components/common';
import GroupItem from './group-item/ui';
import * as st from './styles.module.scss';

export const ClientsGroupsPage: React.FC = () => {
  // Идентифицирует о том, идет ли сейчас выбор или нет
  const { isSelecting: isGroupsSelecting, setIsSelectingFalse } = useIdsSelecting('groups');
  const { doRedirectOnPrevPage } = usePagesRedirect('groups');
  const { is_can_view_other_specialists } = usePlatformSettings();

  const { status, groups } = useLoadGroups(true);

  const { groupsWithoutSpecialType, withoutGroup, coachesGroup } = useMemo(
    () => parseGroups(groups),
    [groups]
  );

  useEffect(() => {
    isGroupsSelecting && window.scrollTo(0, 0);
  }, [isGroupsSelecting]);
  const isLoading = status === 'loading';
  return (
    <>
      <Header MCenter={<>Клиенты</>} />
      <PageHead
        Left={
          <>
            {!isGroupsSelecting && (
              <section className={st.nav}>
                <NavLink
                  to={`/clients/clients`}
                  className={({ isActive }) => cn(st.tab, isActive && st.active)}
                >
                  Все
                </NavLink>
                <NavLink
                  to={`/clients/groups`}
                  className={({ isActive }) => cn(st.tab, isActive && st.active)}
                >
                  Группы
                </NavLink>
              </section>
            )}
          </>
        }
        Center={isGroupsSelecting ? 'Выбор групп' : undefined}
        Right={
          <>
            <Tooltip title="Добавить">
              <div>
                <Link to={`edit/new`}>
                  <IconButton variant="dark">
                    <Add />
                  </IconButton>
                </Link>
              </div>
            </Tooltip>
            {isGroupsSelecting && (
              <TextButton
                type="button"
                onClick={() => {
                  doRedirectOnPrevPage();
                  setIsSelectingFalse();
                }}
              >
                Готово
              </TextButton>
            )}
          </>
        }
      />
      <ListBody>
        <InfinityList loadMore={() => {}} loading={isLoading} className={st.groupList}>
          {groupsWithoutSpecialType.map((group) => (
            <GroupItem key={group.id} group={group} />
          ))}
          {withoutGroup && !isGroupsSelecting && (
            <GroupItem key={withoutGroup.id} group={withoutGroup} />
          )}
          {coachesGroup && is_can_view_other_specialists && (
            <GroupItem key={coachesGroup.id} group={coachesGroup} />
          )}
          {!isLoading && !groups.length && <Blank text={'У вас пока нет групп'} />}
        </InfinityList>
      </ListBody>
    </>
  );
};

export default ClientsGroupsPage;
